(function () {
  'use strict';

  const overlay      = document.getElementById('search-overlay');
  const toggleBtns   = document.querySelectorAll('.search-toggle');
  const closeBtn     = document.querySelector('.search-overlay__close-btn');
  const backdrop     = document.querySelector('.search-overlay__backdrop');
  const input        = document.getElementById('search-input');
  const clearBtn     = document.getElementById('search-clear');
  const form         = document.querySelector('.search-overlay__form');
  const staticRows   = document.getElementById('static-rows');
  const resultsRows  = document.getElementById('results-rows');
  const resultsLabel = document.getElementById('results-label');
  const viewAllBtn   = document.getElementById('search-view-all');

  if (!overlay || !toggleBtns.length) return;

  // ── i18n: Texte aus Liquid data-Attributen lesen ─
  var i18n = {
    recommended: overlay.dataset.labelRecommended || 'Auch Zu Empfehlen',
    suggestions: overlay.dataset.labelSuggestions || 'Vorschläge',
    noResults:   overlay.dataset.labelNoResults   || 'Keine Ergebnisse',
  };

  // Aktive Sprache aus Liquid — für lokalisierte API-Requests
  var locale = overlay.dataset.locale || 'de';

  // Aktive Sprache aus Liquid — für lokalisierte API-Requests
  var locale = overlay.dataset.locale || 'de';

  // ── Open / Close ──────────────────────────────────
  function openSearch() {
    overlay.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    });
    toggleBtns.forEach(function(b){ b.setAttribute('aria-expanded', 'true'); });
    input && setTimeout(function () { input.focus(); }, 80);
    document.body.style.overflow = 'hidden';
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    toggleBtns.forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
    setTimeout(function () {
      overlay.hidden = true;
      if (input) input.value = '';
      if (clearBtn) clearBtn.hidden = true;
      showStatic();
    }, 420);
  }

  toggleBtns.forEach(function(b){ b.addEventListener('click', openSearch); });
  closeBtn  && closeBtn.addEventListener('click', closeSearch);
  backdrop  && backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
  });

  // ── View Switching ────────────────────────────────
  function showStatic() {
    if (staticRows)   staticRows.style.display  = '';
    if (resultsRows)  resultsRows.style.display  = 'none';
    if (resultsLabel) resultsLabel.textContent   = i18n.recommended;
    if (viewAllBtn)   viewAllBtn.style.display   = 'none';
  }

  function showLive() {
    if (staticRows)   staticRows.style.display  = 'none';
    if (resultsRows)  resultsRows.style.display  = '';
    if (resultsLabel) resultsLabel.textContent   = i18n.suggestions;
  }

  if (resultsRows) resultsRows.style.display = 'none';
  if (viewAllBtn)  viewAllBtn.style.display  = 'none';

  // ── Helpers ───────────────────────────────────────
  function formatPrice(cents) {
    if (!cents && cents !== 0) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function extractText(html) {
    if (!html) return '';
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var text = (tmp.textContent || tmp.innerText || '').trim().replace(/\s+/g, ' ');
    return text.length > 65 ? text.substring(0, 65) + '\u2026' : text;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function buildRow(p) {
    var imgHtml = (p.featured_image && p.featured_image.url)
      ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="" width="60" height="60" loading="lazy">'
      : '<div class="search-row__img-placeholder"></div>';

    var subtitle = extractText(p.description || '');
    var price    = p.price ? formatPrice(p.price) : '';

    return '<a href="' + escapeHtml(p.url) + '" class="search-row">'
      + '<div class="search-row__img">' + imgHtml + '</div>'
      + '<div class="search-row__info">'
      + '<p class="search-row__title">' + escapeHtml(p.title) + '</p>'
      + (subtitle ? '<p class="search-row__sub">'   + escapeHtml(subtitle) + '</p>' : '')
      + (price    ? '<p class="search-row__price">' + price + '</p>' : '')
      + '</div>'
      + '</a>';
  }

  function renderResults(products, query) {
    if (!resultsRows) return;

    if (products.length === 0) {
      resultsRows.innerHTML = '<p class="search-no-results">' + escapeHtml(i18n.noResults) + '</p>';
      if (viewAllBtn) viewAllBtn.style.display = 'none';
      showLive();
      return;
    }

    resultsRows.innerHTML = products.map(buildRow).join('');

    if (viewAllBtn) {
      viewAllBtn.style.display = 'inline-block';
      viewAllBtn.onclick = function () {
        window.location.href = '/search?type=product&q=' + encodeURIComponent(query);
      };
    }

    showLive();
  }

  // ── Fetch: vollständige Produktdaten per Handle ───
  function fetchFullProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        return {
          title:          prod.title,
          url:            '/products/' + prod.handle,
          featured_image: prod.featured_image ? { url: prod.featured_image } : null,
          description:    prod.description || '',
          price:          prod.variants && prod.variants[0] ? prod.variants[0].price : prod.price
        };
      });
  }

  // ── Shopify Predictive Search ─────────────────────
  function doSearch(query) {
    // Locale-Prefix für lokalisierte Suchergebnisse
    var searchUrl = (locale !== 'de' ? '/' + locale : '')
      + '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=6';

    fetch(searchUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (input && input.value.trim() !== query) return;

        var raw = (data.resources && data.resources.results && data.resources.results.products) || [];

        if (raw.length === 0) {
          renderResults([], query);
          return;
        }

        // Suggest-API: Preis als String "39.90" → Cents, Bild aus image oder featured_image
        var products = raw.map(function (p) {
          var priceStr = p.price || p.price_min || '0';
          var priceCents = Math.round(parseFloat(priceStr) * 100);

          // Bild: API gibt entweder p.image (String-URL) oder p.featured_image.url
          var imgUrl = null;
          if (p.featured_image && p.featured_image.url) {
            imgUrl = p.featured_image.url;
          } else if (typeof p.image === 'string' && p.image) {
            imgUrl = p.image;
          }

          return {
            title:          p.title || '',
            url:            (p.url || '').split('?')[0],
            featured_image: imgUrl ? { url: imgUrl } : null,
            description:    p.body || '',
            price:          priceCents
          };
        });

        renderResults(products, query);
      })
      .catch(function () {});
  }

  // ── Input: Live-Suche ab 1. Zeichen ──────────────
  var searchTimer = null;

  input && input.addEventListener('input', function () {
    var q = input.value.trim();

    if (clearBtn) clearBtn.hidden = q.length === 0;

    if (q.length === 0) {
      clearTimeout(searchTimer);
      showStatic();
      return;
    }

    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      doSearch(q);
    }, 200);
  });

  clearBtn && clearBtn.addEventListener('click', function () {
    if (input) { input.value = ''; input.focus(); }
    clearBtn.hidden = true;
    clearTimeout(searchTimer);
    showStatic();
  });

  // Enter deaktiviert — Nutzer klickt auf Vorschlag
  form && form.addEventListener('submit', function (e) {
    e.preventDefault();
  });

})();